import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import ArrowLink from "../ArrowLink";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import MyImage from "../MyImage";

const ResourcesCard = ({
  slug,
  title,
  commonFields: { label, authors },
  featuredImage,
  categories,
  date,
  podcastFields: { participants },
}) => {
  const category = categories.nodes.length ? categories.nodes[0].name : null;

  const author =
    !!authors && authors.length
      ? authors[0].name
      : "Sustainable Capital Advisors";

  const participant =
    !!participants && participants.length
      ? participants[0].name
      : "Sustainable Capital Advisors";

  const displayAuthor = category === "Podcast" ? participant : author;

  return (
    <div className={styles.resourceCard}>
      <Link href={`/resources/${slug}`} passHref>
        <a>
          <div className={styles.image}>
            {!!categories.nodes.length && (
              <p className={styles.category}>{category}</p>
            )}
            {featuredImage && (
              <MyImage
                objectFit="cover"
                layout="fill"
                src={featuredImage.node.sourceUrl}
                alt={featuredImage.node?.altText || featuredImage.node?.title}
              />
            )}
          </div>
          <div className={styles.content}>
            <div className={styles.top}>
              <span className={styles.date}>
                {date
                  ? new Date(date).toLocaleDateString("en-US", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })
                  : null}
              </span>
              <span className={styles.partner}>{label}</span>
            </div>
            <div
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: title }}
            ></div>
            <p className={styles.author}>{displayAuthor}</p>
            <ArrowLink onClick={() => {}}>Learn more</ArrowLink>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default ResourcesCard;
